/**
 * Use videoPreviewClip for a show video clip on hover.
 * @example
 *   <a video-preview-clip data-src></a>
 */
angular.module('iconoglobe')
.directive('videoPreviewClip', ['$rootScope', function($rootScope){
  return {
    restrict: "A",
    link: function(scope, ele, attrs){
      if(attrs.src == "" || !attrs.src ) { return;}
      var preview = angular.element("<div class='video-preview-clip'></div>");
      ele.append(preview);
      
      var video = document.createElement('video');
      
      ele.bind('mouseenter', function(e){
        if(attrs.src){
          video.src = $rootScope.videoBaseUrl + "clips/" + attrs.src;
          video.muted = true;
          video.autoplay  = true;
          preview.append(video);
        }
      });
      
      ele.bind('mouseleave', function(e){
        // ele.find('video').remove();
      });
    }
  }
}])